import React from 'react'
import { KTIcon } from '../../../../_metronic/helpers'

interface KpiCardProps {
  title: string
  value: string | number
  subtitle?: string
  color: string
  icon: string
}

const KpiCard: React.FC<KpiCardProps> = React.memo(({ title, value, subtitle, color, icon }) => (
  <div className="col">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body d-flex align-items-center gap-4 py-6 px-6">
        <div
          className={`d-flex align-items-center justify-content-center rounded bg-light-${color}`}
          style={{ width: 52, height: 52, minWidth: 52 }}
        >
          <KTIcon iconName={icon} className={`fs-1 text-${color}`} />
        </div>
        <div>
          <div className="text-gray-500 fs-7 fw-semibold">{title}</div>
          <div className="fw-bolder text-gray-900 fs-2">{value ?? 0}</div>
          {subtitle ? <div className="text-gray-500 fs-8">{subtitle}</div> : null}
        </div>
      </div>
    </div>
  </div>
))

export default KpiCard
